// @flow
/* eslint-disable no-restricted-globals */

import { importScript } from '@ta/platform.import';

export const addTagManagerScript = (tagMgrId: string) => {
  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${tagMgrId}`;

  if (typeof document !== 'undefined') {
    setTimeout(() => {
      importScript(scriptSrc, 'ADS');

      window.dataLayer = window.dataLayer || [];
      // Stuff will break if the gtag fn is not defined as below.
      // eslint-disable-next-line no-unused-vars
      function gtag(arg1, arg2) {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      }
      gtag('js', new Date());
      gtag('config', tagMgrId);
    }, 500);
  }
};

export { addTagManagerScript as default };
